import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home'
import about from '@/view/about'
import acti from '@/view/acti'
import actiEdit from '@/view/actiEdit'
import recruit from '@/view/recruit'
import news from '@/view/new'
import newsList from '@/view/newsList'
import contactUs from '@/view/contactUs'
// import organizational from '@/view/organizational'
import search from '@/view/search'
import project from '@/view/project'
import technology from '@/view/technology'

Vue.use(Router)
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/about/:type',
      name: 'about',
      component: about
    },
    {
      path: '/acti',
      name: 'acti',
      component: acti
    },
    {
      path: '/actiEdit',
      name: 'actiEdit',
      component: actiEdit
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: recruit
    },
    {
      path: '/new/:id',
      name: 'new',
      component: news
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: newsList
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    },
    // {
    //   path: '/organizational',
    //   name: 'organizational',
    //   component: organizational
    // },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/project/:type',
      name: 'project',
      component: project
    },
    {
      path: '/technology',
      name: 'technology',
      component: technology
    }
  ],
  scrollBehavior (route) {
    if (route === 'about') {
      window.scrollTo({
        top: 0,
        behavior:'smooth'
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js